export const endpoints = {
  spaces: "spaces",
  accounts: "accounts",
  users: "users",
  permissions: "permissions",
  userTypes: "user-types",
  userTypePermissions: "typology-permissions",
  roles: "roles",
  rolePermissions: "role-permissions",
  organizations: "organizations",
  orgMembers: "org-members",
  brands: "brands",
  brandCategories: "brand-categories",
  brandPrincipals: "brand-principals",
  tags: "tags",
  searchViews: "search-views",
  searchFields: "search-fields",
  timezones: "time-zones",
  documentation: "documentation",
  documents: "documents",
  files: "files",
  communications: "communications",
  inbox: "inbox",
  importJobs: "import-jobs",
  imports: "imports",
  active: "active",
  logs: "logs",
  notifications: "notifications",
  analytics: "analytics",
  customEndpoint: "custom",

  contracts: "contracts",
  contractProducts: "contract-products",
  contractTemplates: "contract-templates",
  contractCollections: "contract-collections",
  contractAutomationTemplates: "automations",
  contractStates: "contract-states",
  contractFields: "contract-fields",
  contractCharges: "contract-charges",
  customers: "customers",
  products: "products",
  productCategories: "product-categories",
  productSuperstates: "product-superstates",
  productOptions: "product-options",
  productStates: "product-states",
  productSubCategories: "product-subcategories",
  workProfiles: "work-profiles",
  brandWorkProfiles: "brand-work-profiles",
  workflows: "workflows",
  workGroups: "work-groups",

  compensationPlans: "compensation-plans",
  compensationTargets: "compensation-targets",
  compensationTargetLogics: "compensation-target-logics",
  contractBillingCycles: "contract-billing-cycles",
  contractBillingCycleEntries: "contract-billing-cycle-entries",
  contractBilling: "contract-billing",
  paymentDetails: "payment-details",
  commissionRates: "commission-rates",
  exportTemplates: "export-templates",
};
